export const SUBSCRIPTIONS_INDEX_TOUR = {
  id: "subscriptions_index",
  steps: [
    {
      element: '[data-tour="subscriptions-create"]',
      popover: {
        title: "Nova assinatura",
        description:
          "Selecione um cliente existente para criar uma assinatura de plano para ele.",
        side: "bottom",
      },
    },
    {
      element: '[data-tour="subscriptions-list"]',
      popover: {
        title: "Todas as assinaturas",
        description:
          "Acompanhe gateway, status e próxima renovação de cada assinatura ativa ou encerrada.",
        side: "top",
      },
    },
  ],
};
